export const RAG_API_URL = "https://rag.dev.myrevive.app";
export const AVATAR_API_URL = "https://api.heygen.com";
export const API_URL = "https://olegtorsunov.com";
export const RAG_API_PRO_URL = "https://rag.dev.torsunov.pro";
export const YANDEX_CDN = "https://storage.yandexcloud.net";
export const SITE_SERVER_URL = process.env.REACT_APP_SITE_SERVER_URL || "https://site-server.dev.torsunov.pro";
export const TRANSLATION_SERVER_URL = "https://translation-manag-server.dev.torsunov.pro";
// Live 1:1 conversation control plane (the `streaming` service, Traefik-routed).
// site_eng calls it DIRECTLY rather than proxying through site_server: streaming
// verifies the same site session JWT itself, so there is no proxy layer to keep
// in sync.
export const LIVE_API_URL = process.env.REACT_APP_LIVE_API_URL || "https://live.dev.torsunov.pro";
// «Кто прав» show console (separate service). Admin-only: /admin/show trades the site session
// token for a one-time code there (POST /api/auth/handoff); the show checks ADMIN_EMAILS itself.
export const SHOW_URL = process.env.REACT_APP_SHOW_URL || "https://kto-prav.dev.torsunov.pro";
// The lecturer's own screen, on the capture console — the wall of viewers that
// becomes the 1:1 the moment an admin connects someone. It is a DIFFERENT host,
// so this is only ever rendered as a link for the seat holder.
// The capture console itself. NOT a /lecturer path: that app has no router at
// all -- App.tsx renders the console at the root -- and the lecturer surface is
// part of that page, because it publishes the camera the recorder already
// holds. A path that does not exist would have sent the lecturer to a 404.
export const LECTURER_SCREEN_URL =
    process.env.REACT_APP_CAPTURE_URL || "https://capture.dev.torsunov.pro";
